<template>
  <div class="modal" :class="{'modal-open': show}">
    <div class="modal-box text-center p-4">
      <button class="btn loading btn-ghost btn-lg text-sm before:!ml-6 !text-black">{{__('please wait...')}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['show']
}
</script>
